import { Grid } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import classes from './Finanzas.module.css';

const Finanzas = () => {
	//Filters
	/* const [country, setCountry] = useState('Chile');
	const [moneda, setMoneda] = useState('CLP');
	const [initialDate, setInitialDate] = useState('2019-01-01');
	const [endDate, setEndDate] = useState('2019-11-30');
	const [clasificacion, setClasificacion] = useState(1); */

	//Apis
	//const [unitEconomicsUrl, setUnitEconomicsUrl] = useState(`/unitEconomicsBills?pais=${country}&moneda=${moneda}`);
	//const [unitEconomicsEmpresasBillsUrl, setunitEconomicsEmpresasBillsUrl] = useState(
	//	`/unitEconomicsEmpresasBills?pais=${country}&moneda=${moneda}`,
	//);
	//const [freeTrialsUrl, setFreeTrialsUrl] = useState(`/freeTrials`);

	//Data
	//const [unitEconomics, setDataUnitEconomics] = useState([]);
	//const [unitEconomicsEmpresasBills, setUnitEconomicsEmpresasBills] = useState([]);
	//const [freeTrials, setDataFreeTrials] = useState([]);

	//Aux
	//const [isLoading, setIsLoading] = useState(false);
	//const [isError, setIsError] = useState(false);

	useEffect(
		() => {
			/* const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);

			Axios.all([Axios.get(unitEconomicsUrl), Axios.get(unitEconomicsEmpresasBillsUrl)]).then(
				Axios.spread((obj1, obj2) => {
					try {
						setDataUnitEconomics(obj1.data);
						setUnitEconomicsEmpresasBills(obj2.data);
					} catch (error) {
						setIsError(true);
					}
					setIsLoading(false);
				}),
			);
		};
		fetchData(); */
		},
		[
			/* unitEconomicsUrl, unitEconomicsEmpresasBillsUrl */
		],
	);

	return (
		<Fragment>
			{/*<FormControl className={classes.formControl}> */}
			<form
				onSubmit={event => {
					event.preventDefault();
					//handleFilter();
				}}
			>
				<div className={classes.card}>
					<Grid container spacing={3}>
						{/* <Paper className={classes.paper}> */}

						<Grid item xs={2}>
							<select>
								<option value={'Chile'}>Chile</option>
								<option value={'Peru'}>Peru</option>
								<option value={'Argentina'}>Argentina</option>
							</select>
						</Grid>

						<Grid item xs={2}>
							<select>
								<option value={'1'}>Pyme</option>
								<option value={'2'}>Corp</option>
							</select>
						</Grid>

						<Grid item xs={2}>
							<select>
								<option value={'CLP'}>CLP</option>
								<option value={'USD'}>USD</option>
								<option value={'PEN'}>PEN</option>
							</select>
						</Grid>

						<Grid item xs={2}>
							<input type="date" id="dateDesde" />
						</Grid>

						<Grid item xs={2}>
							<input type="date" id="dateHasta" />
						</Grid>

						<Grid item xs={2}>
							<input type="submit" value="Filtrar" />
						</Grid>
					</Grid>
				</div>
			</form>
			<div>
				<br></br>
			</div>
			{/* SECCIÓN 1 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<div className={classes.Green}>
							<div>Pagado este Mes</div>
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.Yellow}>
							<div>Por Vencer</div>
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.Red}>
							<div>Vencidas</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* Sección 2 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.card}>
							<div>Gráfico Brutos</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* Sección 4 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<div className={classes.card}>Gráfico Facturas</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
	// return React.createElement('div', {className: 'App'}, React.createElement('h1', null, 'Does this work now?'));
};

export default withRouter(React.memo(withErrorHandler(Finanzas, Axios)));
